import { render, staticRenderFns } from "./RrcvE_Details.vue?vue&type=template&id=1dc05e90"
import script from "./RrcvE_Details.vue?vue&type=script&lang=js"
export * from "./RrcvE_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports